"use strict";

Shopify.theme.jsAccounts = {
  init: function init($section) {
    $('.js-recover-password').on('click', function (e) {
      e.preventDefault();
      $('#login').hide();
      $('#recover').show();
    });
    $('.cancel-recover-password').on('click', function (e) {
      e.preventDefault();
      $('#recover').hide();
      $('#login').show();
    });
  },
  unload: function unload($section) {
    $('.js-recover-password').off();
    $('.cancel-recover-password').off();
  }
};
Shopify.theme.jsAccounts.init();
toggleRecoverHash();

function toggleRecoverHash() {
  if (window.location.hash === '#recover') {
    $('#login').hide();
    $('#recover').show();  
    window.location.hash = '';
  } else {
      $('#recover').hide();
      $('#login').show();
    window.location.hash = 'recover';
  }
}